/**
 * Sneakzmarket: Pflicht zur Variantenauswahl auf der Produktseite (Ergänzungen).
 *
 * WICHTIG: Die eigentliche Add-to-Cart-SPERRE wird INLINE in sections/product.liquid
 * registriert (synchron, vor allen deferred-Skripten), um die Race Condition
 * "Error: Cannot find variant" zu vermeiden. Diese (deferred) Datei liefert nur die
 * Ergänzungen nach, die kein hartes Timing brauchen:
 *  1) Hinweis einer Gruppe entfernen, sobald darin gewählt wird.
 *  2) Express-Checkout-Buttons (Shop Pay etc.) je nach Auswahlstatus ein-/ausblenden.
 *  3) Nach Broadcasts AJAX-Re-Render die gewählten Radios wieder markieren.
 *  4) Das serverseitig immer befüllte Wert-Label leeren, solange nichts gewählt ist.
 *
 * Das versteckte Feld [name="id"] ist die "Single Source of Truth": leer = keine Auswahl.
 */
(function () {
  'use strict';

  var SEL_FORM = 'form[data-type="add-to-cart-form"]';
  var SEL_OPTION_GROUP = '[data-option-position]';
  var SEL_HINT = '[data-variant-required-hint]';
  var CLASS_NEEDS_CHOICE = 'selector-wrapper--needs-choice';
  var CLASS_NOT_CHOSEN = 'variant-not-chosen';

  function variantIdInput(form) {
    return form.querySelector('[name="id"]');
  }

  function hasVariant(form) {
    var input = variantIdInput(form);
    return !!(input && input.value && input.value.trim() !== '');
  }

  function clearHint(group) {
    group.classList.remove(CLASS_NEEDS_CHOICE);
    var hint = group.querySelector(SEL_HINT);
    if (hint) hint.hidden = true;
  }

  // Express-Buttons abhängig vom Auswahlstatus ein-/ausblenden.
  function syncExpress(form) {
    var submit = form.closest('.product__submit') || form;
    submit.classList.toggle(CLASS_NOT_CHOSEN, !hasVariant(form));
  }

  // Solange in einer Options-Gruppe nichts markiert ist, das serverseitig immer
  // befüllte Wert-Label (z.B. "EU 41") leeren, damit nicht fälschlich eine Auswahl
  // suggeriert wird. Nach einer echten Auswahl füllt Broadcasts Re-Render es wieder.
  function clearEmptyValueLabels() {
    document.querySelectorAll('variant-selects ' + SEL_OPTION_GROUP).forEach(function (group) {
      if (group.querySelector('input:checked')) return;
      var label = group.querySelector('[data-selected-value]');
      if (label) label.textContent = '';
    });
  }

  /*
   * Radios nach Broadcasts AJAX-Re-Render wieder markieren.
   * Hintergrund: Broadcast lädt die Section per ?option_values=… neu. In diesem
   * Fragment ist product.selected_variant leer (nur ?variant= setzt es), daher
   * rendert der Server die Radios erneut unmarkiert. Sobald eine vollständige
   * Variante aufgelöst ist, feuert Broadcast variantChange – hier markieren wir
   * die zugehörigen Radios wieder, damit die gewählte Grösse hervorgehoben bleibt.
   * input.checked = true löst KEIN change-Event aus → keine Schleife.
   */
  function recheckSelected(variant, sectionId) {
    if (!variant || !variant.options) return;
    var vs = sectionId
      ? document.querySelector('variant-selects[data-section="' + sectionId + '"]')
      : document.querySelector('variant-selects');
    if (!vs) return;

    vs.querySelectorAll(SEL_OPTION_GROUP).forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      var value = pos ? variant.options[pos - 1] : null;
      if (value == null) return;

      group.querySelectorAll('input[type="radio"]').forEach(function (input) {
        if (input.value === String(value)) input.checked = true;
      });
      clearHint(group);
    });
  }

  function subscribeVariantChange() {
    if (typeof window.subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = (event && event.data) || {};
      recheckSelected(data.variant, data.sectionId);
    });
  }

  /*
   * Schutz gegen doppelte "id"-Felder (Ursache der Falschbestellungen 07/2026):
   * Broadcasts updateVariantInputs() aktualisiert nur das id-Feld INNERHALB des
   * <form>. Jedes weitere form-assoziierte Feld (z.B. <input name="id" form="…">
   * ausserhalb des Formulars, wie es upstream in snippets/product.liquid stand)
   * behält seinen Server-Wert (erste verfügbare Variante) und landet als ERSTER
   * "id"-Eintrag in der FormData. /cart/add nimmt den letzten Eintrag, Shopifys
   * Express-Checkout (Shop Pay / "Jetzt kaufen") aber den ersten → kleinste Grösse.
   * Deshalb: alle "id"-Felder des Formulars auf den Wert des Formular-internen
   * Feldes angleichen, sobald sich dieses ändert. Greift auch, falls ein Upstream-
   * Merge das zweite Feld wieder einführt.
   */
  function syncDuplicateIdInputs(form) {
    var primary = variantIdInput(form);
    if (!primary || !form.elements) return;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el !== primary && el.name === 'id' && el.value !== primary.value) {
        el.value = primary.value;
      }
    });
  }

  // 1) Auswahl getroffen → Hinweis weg; id-Feld geändert → Express-Status aktualisieren.
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var group = target.closest(SEL_OPTION_GROUP);
    if (group) clearHint(group);

    if (target.matches && target.matches('[name="id"]')) {
      var form = target.closest(SEL_FORM);
      if (form) {
        syncDuplicateIdInputs(form);
        syncExpress(form);
      }
    }
  });

  // 2) Initialzustand + nach Broadcast-Re-Render: Express-Buttons synchronisieren
  //    und leere Wert-Labels bereinigen.
  function init() {
    document.querySelectorAll(SEL_FORM).forEach(function (form) {
      syncDuplicateIdInputs(form);
      syncExpress(form);
    });
    clearEmptyValueLabels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      subscribeVariantChange();
    });
  } else {
    init();
    subscribeVariantChange();
  }
  document.addEventListener('theme:product-info:loaded', init);
})();
